let tableQueryConfig = {
  version: 5.5,
  queryConfig: [
    {
      label: '纳税人识别号',
      selected: true,
      default: true,
    },
    {
      label: '纳税人名称',
      selected: true,
      default: true,
    },
    {
      label: '申报状态',
      selected: true,
      default: true,
    },
    {
      label: '所属大区',
      selected: false,
      default: false,
    },
    {
      label: '管理城市',
      selected: false,
      default: false,
    },
    {
      label: '主管税局所在省市',
      selected: false,
      default: false,
    },
    {
      label: '事业部',
      selected: false,
      default: false,
    },
    {
      label: '是否开启申报',
      selected: true,
      default: true,
    },
    {
      label: '跟进人',
      selected: true,
      default: true,
    },
  ],
  table: [
    {
      label: '纳税人名称',
      selected: true,
      default: true,
    },
    {
      label: '纳税人识别号',
      selected: true,
      default: true,
    },
    {
      label: '申报状态',
      selected: true,
      default: true,
    },
    {
      label: '事业部',
      selected: false,
      default: false,
    },
    {
      label: '所属大区',
      selected: false,
      default: false,
    },
    {
      label: '管理城市',
      selected: false,
      default: false,
    },
    {
      label: '主管税局所在省市',
      selected: false,
      default: false,
    },
    {
      label: '营业收入',
      selected: true,
      default: true,
    },
    {
      label: '营业成本',
      selected: true,
      default: true,
    },
    {
      label: '利润总额',
      selected: true,
      default: true,
    },
    {
      label: '减:资产加速折旧、摊销(扣除)调减额(填写A201020)',
      selected: true,
      default: true,
    },
    {
      label: '减:本年实际已缴纳所得税额',
      selected: true,
      default: true,
    },
    {
      label: '分支机构本期分摊应补(退)所得税额',
      selected: true,
      default: true,
    },
    {
      label: ' 总机构本期分摊应补(退)所得税额(18+19+20)',
      selected: true,
      default: true,
    },
    {
      label: '分支机构本期分摊比例',
      selected: true,
      default: true,
    },
    {
      label: ' 减：所得减免(8.1+8.2+…)',
      selected: true,
      default: true,
    },
    {
      label: '是否开启申报',
      selected: true,
      default: true,
    },
    {
      label: '减：免税收入、减计收入、加计扣除(7.1+7.2+...)',
      selected: true,
      default: true,
    },
    {
      label: '期末_资产合计',
      selected: true,
      default: true,
    },
    {
      label: '期末_负债合计',
      selected: true,
      default: true,
    },
    {
      label: '期末_未分配利润',
      selected: true,
      default: true,
    },
    {
      label: '期末_所有者权益合计',
      selected: true,
      default: true,
    },
    {
      label: '本年累计_营业收入',
      selected: true,
      default: true,
    },
    {
      label: '本年累计_营业成本',
      selected: true,
      default: true,
    },
    {
      label: '本年累计_销售费用',
      selected: true,
      default: true,
    },
    {
      label: '本年累计_管理费用',
      selected: true,
      default: true,
    },
    {
      label: '本年累计_研究费用',
      selected: true,
      default: true,
    },
    {
      label: '本年累计_财务费用',
      selected: true,
      default: true,
    },
    {
      label: '本年累计_利润总额',
      selected: true,
      default: true,
    },
    {
      label: '本年累计_经营活动产生的现金流量净额',
      selected: true,
      default: true,
    },
    {
      label: '本年累计_投资活动产生的现金流量净额',
      selected: true,
      default: true,
    },
    {
      label: '本年累计_筹资活动产生的现金流量净额',
      selected: true,
      default: true,
    },
    {
      label: '本年累计_期初现金余额',
      selected: true,
      default: true,
    },
    {
      label: '本年累计_期末现金余额',
      selected: true,
      default: true,
    },
    {
      label: '财务报表下载',
      selected: true,
      default: true,
    },
    {
      label: `本期应补(退)所得税额(12-13-14-15)${decodeURI(
        '%5C'
      )}税务机关确定的本期应纳所得税额`,
      selected: true,
      default: true,
    },
    {
        label: '跟进人',
        selected: true,
        default: true,
    },
  ],
};

export default tableQueryConfig;



// WEBPACK FOOTER //
// ./src/app/declaration/corporateIncomeTax/enterpriseReportQuery/tableQueryConfig.js